import BROWSER_TITLES from 'constants/browserTitles';

export const setBrowserTitle = (detail, section, root) => {
    if (window && window.document) {
        const browserTitle = constructBrowserTitle(detail, section, root);

        setTimeout(() => {
            window.document.title = browserTitle;
        }, 0);
    }
    return true;
};

export const resetBrowserTitle = () => {
    if (window && window.document) {
        window.document.title = BROWSER_TITLES.DEFAULT;
    }
    return true;
};

export const constructBrowserTitle = (detail, section, root) => {
    let browserTitle = BROWSER_TITLES.DEFAULT;

    if (typeof root === 'string') {
        browserTitle = root;
    }
    if (typeof section === 'string') {
        browserTitle = `${section} - ${browserTitle}`;
    }
    if (typeof detail === 'string') {
        browserTitle = `${detail} - ${browserTitle}`;
    }

    return browserTitle;
};

export const createBrowserTitleDetail = miscSettings => {
    let browserTitleDetail = null;

    if (miscSettings.helpCategoryType) {
        switch (miscSettings.helpCategoryType) {
            case 'cases':
                browserTitleDetail = BROWSER_TITLES.HELP_CENTER.CASES;
                break;
            case 'company-policies':
                browserTitleDetail =
                    BROWSER_TITLES.HELP_CENTER.COMPANY_POLICIES_AND_SMART_HANDBOOKS;
                break;
            case 'getting-started':
                browserTitleDetail = BROWSER_TITLES.HELP_CENTER.GETTING_STARTED;
                break;
            case 'hr-compliance':
                browserTitleDetail = BROWSER_TITLES.HELP_CENTER.HR_COMPLIANCE;
                break;
            case 'learn':
                browserTitleDetail = BROWSER_TITLES.HELP_CENTER.LEARN;
                break;
            case 'my-dashboard':
                browserTitleDetail = BROWSER_TITLES.HELP_CENTER.MY_DASHBOARD;
                break;
            case 'safety':
                browserTitleDetail = BROWSER_TITLES.HELP_CENTER.SAFETY;
                break;
            case 'smart-handbooks':
                browserTitleDetail = BROWSER_TITLES.HELP_CENTER.SMART_HANDBOOKS;
                break;
            default:
                browserTitleDetail = null;
        }
    }

    return browserTitleDetail;
};
